// @flow
export { default } from './QuoteLikeButton';



// WEBPACK FOOTER //
// ./src/components/quote/QuoteLikeButton/index.js